import { Component, OnInit } from '@angular/core';
import {  RouterModule } from '@angular/router';

@Component({
    selector: 'app-nude-layout',
    templateUrl: './nude-layout.component.html',
    styleUrls: ['./nude-layout.component.scss'],
    imports: [RouterModule]
})
export class NudeLayoutComponent implements OnInit {
  isDisplayingNav = false;
  constructor() {}

  ngOnInit(): void {}
}
